'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('./baseEntity'),
    BaseEntity = _require.BaseEntity;

var _require2 = require('../resource'),
    ForschungsberichtResource = _require2.ForschungsberichtResource;

module.exports.Forschungsbericht = function (_BaseEntity) {
  _inherits(Forschungsbericht, _BaseEntity);

  _createClass(Forschungsbericht, null, [{
    key: '__name__',
    value: function __name__() {
      return 'forschungsbericht';
    }
  }]);

  function Forschungsbericht(data) {
    _classCallCheck(this, Forschungsbericht);

    var _this = _possibleConstructorReturn(this, (Forschungsbericht.__proto__ || Object.getPrototypeOf(Forschungsbericht)).call(this));

    _this._entityName = 'de.ul.fob.domain.Forschungsbericht';
    _this.istFinal = false;
    _this.istOffiziell = null;
    _this.titel = null;
    _this.year = null;

    _this.forschungsprojekt = null;
    _this.kooperation = null;
    _this.nachwuchsfoerderung = null;
    _this.organisationseinheit = null;
    _this.patent = null;
    _this.preis = null;
    _this.publikation = null;
    _this.strukturiertesPromotionsprogramm = null;
    _this.ueberForschungsbericht = null;
    _this.unterForschungsbericht = null;
    _this.veranstaltung = null;
    _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'init', _this).call(_this, data);
    return _this;
  }

  _createClass(Forschungsbericht, [{
    key: 'toPostData',
    value: function toPostData() {
      return this.genericJSON({
        fields: ['_id', 'istFinal', 'istOffiziell', 'titel', 'year'],
        links: ['forschungsprojekt', 'kooperation', 'nachwuchsfoerderung', 'organisationseinheit', 'patent', 'preis', 'publikation', 'strukturiertesPromotionsprogramm', 'ueberForschungsbericht', 'unterForschungsbericht', 'veranstaltung']
      });
    }
  }, {
    key: 'fetchForschungsprojekt',
    value: function fetchForschungsprojekt() {
      return _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'forschungsprojekt');
    }
  }, {
    key: 'fetchKooperation',
    value: function fetchKooperation() {
      return _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'kooperation');
    }
  }, {
    key: 'fetchNachwuchsfoerderung',
    value: function fetchNachwuchsfoerderung() {
      return _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'nachwuchsfoerderung');
    }
  }, {
    key: 'fetchOrganisationseinheit',
    value: function fetchOrganisationseinheit() {
      return _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'organisationseinheit');
    }
  }, {
    key: 'fetchPatent',
    value: function fetchPatent() {
      return _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'patent');
    }
  }, {
    key: 'fetchPreis',
    value: function fetchPreis() {
      return _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'preis');
    }
  }, {
    key: 'fetchPublikation',
    value: function fetchPublikation() {
      return _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'publikation');
    }
  }, {
    key: 'fetchStrukturiertesPromotionsprogramm',
    value: function fetchStrukturiertesPromotionsprogramm() {
      return _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'strukturiertesPromotionsprogramm');
    }
  }, {
    key: 'fetchUeberForschungsbericht',
    value: function fetchUeberForschungsbericht() {
      return _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'ueberForschungsbericht');
    }
  }, {
    key: 'fetchUnterForschungsbericht',
    value: function fetchUnterForschungsbericht() {
      return _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'unterForschungsbericht');
    }
  }, {
    key: 'fetchVeranstaltung',
    value: function fetchVeranstaltung() {
      return _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'veranstaltung');
    }
  }, {
    key: 'fetchAll',
    value: function fetchAll() {
      return Promise.all([_get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'forschungsprojekt'), _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'kooperation'), _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'nachwuchsfoerderung'), _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'organisationseinheit'), _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'patent'), _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'preis'), _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'publikation'), _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'strukturiertesPromotionsprogramm'), _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'ueberForschungsbericht'), _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'unterForschungsbericht'), _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'genericResolve', this).call(this, 'veranstaltung')]);
    }
  }, {
    key: 'fetchResource',
    value: function fetchResource() {
      if (typeof ForschungsberichtResource === 'undefined') {
        return this.fetchAll();
      } else {
        return _get(Forschungsbericht.prototype.__proto__ || Object.getPrototypeOf(Forschungsbericht.prototype), 'fetchQuery', this).call(this, ForschungsberichtResource);
      }
    }
  }]);

  return Forschungsbericht;
}(BaseEntity);


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/entity/forschungsbericht.js
// module id = g7qQ
// module chunks = 0